import { render } from "./inventorylab.vue?vue&type=template&id=403bd3cb"
import script from "./inventorylab.vue?vue&type=script&lang=js"
export * from "./inventorylab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__